import React from 'react';
import PremiumQuiz from '../components/PremiumQuiz';

const QUESTIONS = [
  { id: 1, text: "Qual sua formação profissional?", options: [
    { label: "Psicologia", value: 3 }, { label: "Medicina / Psiquiatria", value: 3 }, { label: "Enfermagem / Assistência Social / Terapia Ocupacional", value: 2 }, { label: "Outra área da saúde ou humanas", value: 1 },
  ]},
  { id: 2, text: "Você tem experiência no atendimento a pessoas com dependência química ou compulsões?", options: [
    { label: "Nenhuma experiência", value: 0 }, { label: "Alguma experiência informal", value: 1 }, { label: "1-3 anos de experiência", value: 2 }, { label: "Mais de 3 anos", value: 3 },
  ]},
  { id: 3, text: "Você conhece os 12 Passos (AA/NA) ou modelos derivados?", options: [
    { label: "Nunca ouvi falar", value: 0 }, { label: "Conheço superficialmente", value: 1 }, { label: "Estudei o tema", value: 2 }, { label: "Trabalho com esse modelo", value: 3 },
  ]},
  { id: 4, text: "Você tem interesse em atendimento online?", options: [
    { label: "Não tenho interesse", value: 0 }, { label: "Tenho curiosidade", value: 1 }, { label: "Já atendo online", value: 2 }, { label: "Atendo online e presencial", value: 3 },
  ]},
  { id: 5, text: "Qual sua familiaridade com Psicologia Analítica (Jung)?", options: [
    { label: "Nenhuma", value: 0 }, { label: "Conheço o básico", value: 1 }, { label: "Estudei formalmente", value: 2 }, { label: "É minha abordagem principal", value: 3 },
  ]},
  { id: 6, text: "Você tem interesse em se certificar para trabalhar com dependência?", options: [
    { label: "Não no momento", value: 0 }, { label: "Estou considerando", value: 1 }, { label: "Sim, estou buscando", value: 2 }, { label: "É minha prioridade", value: 3 },
  ]},
  { id: 7, text: "Você já trabalhou com entrevista motivacional?", options: [
    { label: "Não conheço", value: 0 }, { label: "Conheço a teoria", value: 1 }, { label: "Já apliquei", value: 2 }, { label: "Uso regularmente", value: 3 },
  ]},
  { id: 8, text: "Você tem registro profissional ativo (CRP, CRM, COREN, etc.)?", options: [
    { label: "Não tenho", value: 0 }, { label: "Em processo de obtenção", value: 1 }, { label: "Sim, tenho", value: 3 }, { label: "Sim, com especialização na área", value: 3 },
  ]},
  { id: 9, text: "Quantos pacientes você atende por semana atualmente?", options: [
    { label: "Nenhum (não atendo)", value: 0 }, { label: "1 a 5", value: 1 }, { label: "6 a 15", value: 2 }, { label: "Mais de 15", value: 3 },
  ]},
  { id: 10, text: "O que mais te atrai na plataforma U-Clean?", options: [
    { label: "Curiosidade geral", value: 0 }, { label: "Ampliar minha rede de pacientes", value: 1 }, { label: "A formação e certificação PAREI-AD", value: 2 }, { label: "Contribuir com a causa da recuperação", value: 3 },
  ]},
];

const CONFIG = {
  role: 'profissional',
  icon: 'Briefcase',
  accentColor: '#06b6d4',
  accentColorAlt: '#22d3ee',
  welcomeTitle: 'Avalie seu perfil profissional',
  welcomeSubtitle: 'Descubra como a U-Clean pode potencializar sua atuação na área de recuperação',
  ctaText: 'Criar Meu Perfil Profissional',
  disclaimer: 'A certificação PAREI-AD estará disponível após o cadastro na plataforma.',
};

function getResult(score) {
  if (score <= 10) return {
    level: 'explorador', iconName: 'Briefcase', neonColor: '#3b82f6',
    title: 'Perfil Explorador',
    headline: 'Uma nova jornada começa aqui',
    message: 'Você está começando a conhecer a área. A U-Clean oferece o Curso PAREI-AD completo para capacitação profissional em dependência, com certificação ao final.',
  };
  if (score <= 20) return {
    level: 'intermediario', iconName: 'AlertTriangle', neonColor: '#f59e0b',
    title: 'Perfil Intermediário',
    headline: 'Você tem boa base para atuar',
    message: 'Você tem boa base para atuar com dependência. A U-Clean permite que você complete sua formação com o Método PAREI-AD, crie seu perfil profissional e comece a atender.',
  };
  return {
    level: 'avancado', iconName: 'Award', neonColor: '#22c55e',
    title: 'Perfil Avançado',
    headline: 'Sua experiência é valiosa',
    message: 'Você tem experiência sólida na área. Na U-Clean você pode se certificar no Método PAREI-AD, criar seu perfil público, agendar consultas e participar de salas de supervisão.',
  };
}

export default function QuizProfissionais() {
  return <PremiumQuiz questions={QUESTIONS} config={CONFIG} getResult={getResult} />;
}
